import React from 'react';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
// import { ContextMenuAction } from 'src/components/common/ContextMenu';
import DialogList from 'src/dialogs';
import OwnerNoteDialog from './OwnerNoteDialog';
import './OwnerPageStyles.scss';

// import OwnerNoteDialog from './OwnerNoteDialog';

interface IOwnerNotes {
    ownerData: LeaseGenerationOwnerData;
    ownerLookUpId: number;
    isReadOnly?: boolean;

    showDialog: (dialogName: string) => void;
    hideDialog: () => void;
    refreshContainer: () => void;
}

const OwnerNotes = (props: IOwnerNotes) => {
    // const actions: ContextMenuAction[] = [{ text: 'Edit Owner Note', action: () => props.showDialog(DialogList.ADD_OWNER_NOTE) }];
    const actions = () => {
        props.showDialog(DialogList.ADD_OWNER_NOTE);
    };

    return (
        <>
            <CardContainer className="owner-tracts-results" style={{ overflowY: 'scroll', maxHeight: '342px' }}>
                {!!props?.ownerData?.ownerDetails?.note ? (
                    <Card
                        badge={props.ownerData?.ownerDetails?.ownerLookUpId.toString()}
                        onClick={!props.isReadOnly ? actions : null}
                        style={{ marginTop: '1rem' }}
                        className="note-highlight"
                    >
                        <div>
                            <div>{props.ownerData?.ownerDetails?.note}</div>
                        </div>
                    </Card>
                ) : (
                    <Card>
                        <p style={{ marginLeft: '1rem' }}>No Owner Notes</p>
                    </Card>
                )}
            </CardContainer>
            <OwnerNoteDialog
                ownerData={props?.ownerData?.ownerDetails}
                refreshContainer={props.refreshContainer}
                createNewNote={false}
                hideDialog={props.hideDialog}
            />
        </>
    );
};

export default OwnerNotes;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/OwnerNotes.tsx